import { useTranslation } from 'react-i18next';

import { EmptyCashIcon } from 'assets/img/icons/icons';
import Button from 'components/base/Button';
import './cashSale.scss';

interface EmptyCashBackProps {
  onButtonClick: () => void;
}

const EmptyCashBack = ({ onButtonClick }: EmptyCashBackProps) => {
  const { t } = useTranslation();

  return (
    <div className="cash-empty-container">
      <EmptyCashIcon />
      <p className="mt-3">{t('scan_barcode_or_product')}</p>
      <Button variant="primary" onClick={onButtonClick}>
        {t('add_product')}
      </Button>
    </div>
  );
};

export default EmptyCashBack;
